import { Button } from "@mui/material";
import { neighboringStep, NewJobsFormState } from "./FormState";
import { typedPath } from "typed-path";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import React from "react";

const S = typedPath<NewJobsFormState>();

interface WizardStepButtonBarProps {
  disableNext: boolean;
}

export const WizardStepButtonBar: React.FC<WizardStepButtonBarProps> = ({
  disableNext,
}) => {
  const { t } = useTranslation();
  const { values, setFieldValue, setFieldTouched } =
    useFormikContext<NewJobsFormState>();

  const prevStep = neighboringStep(values, "prev");
  const nextStep = neighboringStep(values, "next");

  return (
    <div className="flex flex-row justify-between">
      <Button
        variant="outlined"
        color="secondary"
        size="large"
        onClick={() => {
          setFieldValue(S.activeStep.$path, prevStep);
          setFieldTouched(S.activeStep.$path, true);
        }}
      >
        {t("utils.actions.backShort")}
      </Button>
      <Button
        variant="contained"
        size="large"
        endIcon={<ArrowForwardIcon />}
        disabled={disableNext}
        onClick={() => {
          setFieldValue(S.activeStep.$path, nextStep);
          setFieldTouched(S.activeStep.$path, true);
        }}
      >
        {t("utils.actions.next")}
      </Button>
    </div>
  );
};
